<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('pets.delete.title') }}</span>
      </v-card-title>
      <v-divider />
      <v-container grid-list-md>
        <v-layout>
          <div class="dialog-content">
            {{ $t('pets.delete.description') }}
          </div>
        </v-layout>
        <v-layout
          row
          justify-end
        >
          <v-flex
            text-md-right
          >
            <v-btn
              color="primary"
              outline
              @click="dialog = false"
            >
              {{ $t('button.no') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="handleDelete"
            >
              {{ $t('button.yes') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import {
  ACTION_DELETE_PET,
} from '../../store/types/pets.types'

export default {
  name: 'DeletePetDialog',
  props: {
    value: Boolean,
    petData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    handleDelete() {
      this.deletePet(this.petData)
      this.dialog = false
    },
    ...mapActions({
      deletePet: ACTION_DELETE_PET,
    }),
  },
}
</script>

<style lang="stylus" scoped>
  .dialog-content {
    margin-bottom: 20px;
  }
</style>
